export default function isYandexOrAtomBrowser() {
    const userAgent = navigator.userAgent || '';
    let brands = '';

    if (navigator.userAgentData && navigator.userAgentData.brands) {
        brands = navigator.userAgentData.brands
            .map((item) => item.brand || '')
            .join(' ');
    }

    const browserInfo = `${userAgent} ${brands}`;

    return /YaBrowser/i.test(browserInfo) || /Atom/i.test(browserInfo);
}
